/**
 * Injects styles into the Listify Shadow DOM whenever it appears (Main page or Quick View)
 */
function applyShadowStyles() {
    // Find all instances of the registry button host
    const hosts = document.querySelectorAll('div[data-registry-add-button]');
  
    hosts.forEach((host) => {
      // Check if it has a shadow root and if we haven't styled it yet
      if (host && host.shadowRoot && !host.dataset.stylesApplied) {
        const style = document.createElement('style');
        style.textContent = `
          button {
            position: relative !important;
            font-family: inherit !important;
            background-color: #ffffff !important;
            color: #2b3887 !important;
            border: 1.5px solid #2b3887 !important;
            border-radius: 5px !important;
            font-size: 14px !important;
            padding: 0.4rem 0.4rem !important;
            width: 40% !important;
            margin-bottom: 1rem !important;
            display: inline-block !important;
            cursor: pointer !important;
            font-weight: 600 !important;
          }
        `;
        host.shadowRoot.appendChild(style);
        
        // Mark this specific button so we don't keep adding styles to it
        host.dataset.stylesApplied = "true";
      }
    });
  }
  
  // 1. Run immediately for the main product page
  applyShadowStyles();
  
  // 2. Watch the page for changes (like a Quick Shop modal opening)
  const observer = new MutationObserver((mutations) => {
    applyShadowStyles();
  });
  
  // Start observing the whole body for added elements
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // 3. Backup: Run every 2 seconds just in case the observer misses a fast-loading app
  setInterval(applyShadowStyles, 2000);